export type { IAnimationStyles, IAnimationVariables } from '@fluentui/theme/lib/types/IAnimationStyles';
